export default "__VITE_ASSET__vSyv_z5J__"